// removed by extract-text-webpack-plugin
module.exports = {"wrapText":"_3pdBiocYgw00Lf0qT5yqIz","translate":"_1H_-_Vw5Mvv5mLIsECtgbV","titleWrapper":"_2nKRxs62YZDh_TaDdGbU7X","translateDescriptionRow":"_3Um7teXnJmfjZ9IApfObnZ","showOriginalDescription":"_19hg2GEAI-wiARKbp79eh3","descriptionTooltip":"qUMJ4lPIlnSzGTeHx1n0c","withOutButton":"_38UpthnVdYJzY_Kt4iWHbr","title":"_1Osd8_G_6pLFbodt1QSkX3","opened":"_1a2gJUumgsc8p_ixKaJiad","willMoreText":"_22pQXFSpMNNz3s0m5zixmp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DescriptionTextBlock/DescriptionTextBlock.scss
// module id = 1573
// module chunks = 0